import { CommonModule } from "@angular/common";
import { booleanAttribute, Component, input, model } from "@angular/core";
import { Input } from "../input.component";
import { BaseInput } from "../base-input";
import { NameTag } from "../../name-tag/name-tag.component";
import { controlValueAccessorProvider } from "../../common/value-accessor";

@Component({
    selector: "app-input-chip",
    templateUrl: "./input-chip.component.html",
    imports: [Input, CommonModule, NameTag],
    providers: [controlValueAccessorProvider(InputChip)],
})
export class InputChip extends BaseInput<string[]> {
    inputValue = model("");
    max = input<number | null>(null);
    commitOnBlur = input<boolean, string | boolean>(false, {
        transform: booleanAttribute,
    });
    commitOnEnter = input<boolean, string | boolean>(true, {
        transform: booleanAttribute,
    });

    keyup(event: KeyboardEvent) {
        if (this.max() && (this.value()?.length || 0) >= this.max()!) {
            return;
        }

        if (event.key === "Enter" && !this.commitOnEnter()) {
            event.preventDefault();
            return;
        }

        if (event.key === "Enter" && this.commitOnEnter()) {
            event.preventDefault();
            this.commitInputValue();
        }
    }

    handleBlur() {
        if (!this.commitOnBlur()) {
            return;
        }

        this.commitInputValue();
    }

    removeChip(index: number) {
        const values = this.value() || [];

        if (index > -1) {
            values.splice(index, 1);
        }

        this.value.set(values);
    }

    private commitInputValue() {
        if (this.max() && (this.value()?.length || 0) >= this.max()!) {
            return;
        }

        const value = this.inputValue().trim();
        const values = [...(this.value() || [])];

        if (value) {
            values.push(value);
            this.inputValue.set("");
        }

        this.value.set(values);
    }
}
